import { bbAxios } from '@bb/session-manager';

import {
  SUBSCRIPTION_STATUS_ENDPOINT,
  SUBSCRIPTION_CHECKOUT_ENDPOINT,
  SUBSCRIPTION_PORTAL_ENDPOINT,
  SUBSCRIPTION_SEATS_ENDPOINT,
  SUBSCRIPTION_USAGE_ENDPOINT,
  SUBSCRIPTION_PRICES_ENDPOINT,
} from '../endpoints.config';

export async function getSubscriptionStatus() {
  const { data } = await bbAxios.get(SUBSCRIPTION_STATUS_ENDPOINT);
  return data;
}

export async function createCheckoutSession(priceId, seats, skipTrial = false) {
  const { data } = await bbAxios.post(SUBSCRIPTION_CHECKOUT_ENDPOINT, { priceId, seats, skipTrial });
  return data;
}

export async function createPortalSession() {
  const { data } = await bbAxios.post(SUBSCRIPTION_PORTAL_ENDPOINT);
  return data;
}

export async function updateSeats(seats) {
  const { data } = await bbAxios.patch(SUBSCRIPTION_SEATS_ENDPOINT, { seats });
  return data;
}

export async function getSubscriptionUsage() {
  const { data } = await bbAxios.get(SUBSCRIPTION_USAGE_ENDPOINT);
  return data;
}

export async function getSubscriptionPrices() {
  const { data } = await bbAxios.get(SUBSCRIPTION_PRICES_ENDPOINT);
  return data;
}

export async function deleteAccount() {
  const { data } = await bbAxios.post('/api/v2/subscription/delete-account');
  return data;
}
